import type { AppLocale } from "./locales";
import { detectBrowserLocale } from "./locales";
import { readStoredLocale } from "./persistence";

let cached: AppLocale | null = null;

export function getInitialLocale(): AppLocale {
  if (cached) return cached;

  cached = readStoredLocale() ?? detectBrowserLocale();

  return cached;
}
